<div class="bg-th-blue mt-0 container-fluid py-2 position-sticky top-0 index-3">

    <div class=" d-flex justify-content-between align-content-center">

        <i class="fa fa-arrow-left text-white my-auto pointer" routerLink="/"></i>

        <p class="text-white f18 my-auto dirI d-flex align-items-center"> داشبورد پیش ثبت‌نام ها </p>

    </div>

</div>

<!-- آماره به تفکیک حوزه -->

<p class="fw-bold text-center bg-blue-light py-2"> آمار به تفکیک حوزه </p>

<div echarts [autoResize]="true" [options]="options | async" id="totalVehicles" class="tree-chart border-bottom"></div>

<div class="row gx-0 gy-3 p-2" style="direction: rtl;">

    <!-- وضعیت نصب -->

    <div class="col-12 col-md-6 p-2 shadow-sm">

        <div class="w-100 h-100">

            <p class="text-center f18"> وضعیت نصب  </p>

            <canvas id="myChart1" style="max-height: 350px !important;"></canvas>

        </div>

    </div>
    
    <!-- پیش ثبت‌نام ها به تفکیک شناور -->

    <div class="col-12 col-md-6 p-2 shadow-sm">

        <div class="w-100 h-100">

            <p class="text-center f18"> پیش ثبت‌نام ها به تفکیک شناور  </p>

            <canvas id="myChart2" style="max-height: 350px !important;"></canvas>

        </div>

    </div>

    <!-- پیش ثبت‌نام ها به تفکیک تاریخ  -->

    <div class="col-12 p-2 shadow-sm">

        <div class="w-100 h-100">

            <p class="text-center f18"> پیش ثبت‌نام ها به تفکیک تاریخ   </p>

            <canvas id="myChart3" style="max-height: 350px !important;"></canvas>

        </div>

    </div>

    <!-- برنامه نصب به تفکیک تاریخ  -->

    <div class="col-12 p-2 shadow-sm">

        <div class="w-100 h-100">

            <p class="text-center f18"> برنامه نصب به تفکیک تاریخ   </p>

            <canvas id="myChart4" style="max-height: 350px !important;"></canvas>

        </div>

    </div>

    <!-- برنامه نصب به تفکیک نصاب   -->

    <div class="col-12 col-md-6 p-2 shadow-sm">

        <div class="w-100 h-100">

            <p class="text-center f18"> برنامه نصب به تفکیک نصاب </p>

            <canvas id="myChart5" style="max-height: 350px !important;"></canvas>

        </div>

    </div>

    <!-- تعداد نصب به تفکیک تاریخ   -->

    <div class="col-12 col-md-6 p-2 shadow-sm">

        <div class="w-100 h-100">

            <p class="text-center f18"> تعداد نصب به تفکیک تاریخ </p>

            <canvas id="myChart6" style="max-height: 350px !important;"></canvas>

        </div>

    </div>

    <!--  پراکندگی پیش ثبت‌نام ها -->

    <div class="col-12 p-2 shadow-sm">

        <div class="w-100 h-100 border p-2">

            <p class="text-center f18 bg-success p-2 rounded text-white "> پراکندگی پیش ثبت‌نام ها </p>

            <div id="Preregistration_Map" class="fixed-mapCluster">

                <div class="position-absolute" id="map_tooltip" data-bs-html="true"></div>

            </div>

        </div>

    </div>

    <!--  پراکندگی نصب -->

    <div class="col-12 p-2 shadow-sm">

        <div class="w-100 h-100 border p-2">

            <p class="text-center f18 bg-success p-2 rounded text-white "> پراکندگی نصب </p>

            <div id="InstallMap" class="fixed-mapCluster">

                <div class="position-absolute" id="map_tooltip" data-bs-html="true"></div>

            </div>

        </div>

    </div>

</div>